import { createWebHistory, createRouter } from "vue-router";

// import store from '@/state/store'
import routes from './routes'

import { isPendingOnboardMerchant, getOnboardingRedirect, isOnboardingPaused } from "./views/onboarding/onboarding";

const ONBOARDING_ROUTES = ["verification", "update-mobile", "onboarding-unavailable"];

const ONBOARDING_PAUSABLE_ROUTES = ["signup", "verification", "update-mobile"];

const MOBILE_APP_EXPERIENCE_ROUTES = new Set([
  "/dashboard/merchant/order",
  "/dashboard/orders/list",
  "/dashboard/static-qr",
  "/dashboard/reports/graph-report",
  "/dashboard/compaigns/list",
  "/dashboard/finance",
  "/dashboard/profile",
  "/dashboard/history/action-history",
]);

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    const isMobileAppRoute = MOBILE_APP_EXPERIENCE_ROUTES.has(to.path);
    const isMobileViewport = typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;

    if (isMobileAppRoute && isMobileViewport) {
      return { left: 0, top: 0 }
    }

    return { x: 0, y: 0 }
  },
})

// Before each route evaluates...
router.beforeEach((to, from, next) => {
  const publicPages = ['/login','/signup','/onboarding-unavailable','/forgot-password','merchant-users/password','/merchant/user/password-reset','/merchant/user/password-create'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('merchant');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  if (isOnboardingPaused() && ONBOARDING_PAUSABLE_ROUTES.includes(to.name)) {
    return next({ name: 'onboarding-unavailable' });
  }

  // Redirect logged-in users away from guest-only pages
  const guestOnlyPages = ['/login', '/signup'];
  if (loggedIn && guestOnlyPages.includes(to.path)) {
    if (isPendingOnboardMerchant()) {
      const redirect = getOnboardingRedirect();
      return next(redirect || '/login');
    }
    return next({ path: '/dashboard/merchant/order' });
  }

  const isOnboardingRoute = ONBOARDING_ROUTES.includes(to.name);

  if (authRequired && loggedIn && isPendingOnboardMerchant() && !isOnboardingRoute) {
    const redirect = getOnboardingRedirect();
    return next(redirect || '/login');
  }

  if (loggedIn && !isPendingOnboardMerchant() && isOnboardingRoute) {
    return next({ path: '/dashboard/merchant/order' });
  }

  next();
});
export default router;